<template>
  <error v-if="error" :error="error" />    
    <div id="basic-info" class="card mt-4">
      <div class="card-header">
        <h5>Register Info</h5>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">Email</label>
              <input v-model="state.email" type="text" class="form-control form-control-default" placeholder="Email">
              <span v-if="v$.email.$error" class="text-sm text-danger">
                    {{ v$.email.$errors[0].$message }}
                </span>
            </div>           
          </div>          
          <div class="col-6">            
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">Display name</label>
              <input v-model="state.displayName" type="text" class="form-control form-control-default" placeholder="Display name">
              <span v-if="v$.displayName.$error" class="text-sm text-danger">
                    {{ v$.displayName.$errors[0].$message }}
                </span>
            </div>       
          </div>          
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">Animal species</label>
              <input v-model="state.animalSpecies" type="text" class="form-control form-control-default" placeholder="Animal species">
              <span v-if="v$.animalSpecies.$error" class="text-sm text-danger">
                    {{ v$.animalSpecies.$errors[0].$message }}
                </span>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-6">
            <div class="input-group input-group-static null">
                <label class="">Telephone number</label>
                <input v-model="state.telephoneNumber" type="text" class="form-control form-control-default" placeholder="Telephone number">
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">Mobile number</label>
              <input v-model="state.mobileNumber" type="text" class="form-control form-control-default" placeholder="Mobile number">
            </div>
          </div>
        </div>        
        <div class="row mt-4">
          <div class="col-12">
            <div class="input-group input-group-static null">
              <label class="">Address</label>
              <input v-model="state.address" type="text" class="form-control form-control-default" placeholder="Address">
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-6">
            <div class="input-group input-group-static null">
                <label class="">City</label>
                <input v-model="state.city" type="text" class="form-control form-control-default" placeholder="City">
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">Zipcode</label>
              <input v-model="state.zipcode" type="text" class="form-control form-control-default" placeholder="Zipcode">
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 mt-6">                                
          <input type="hidden" v-model="state.id" class="form-control">
          <router-link to="/register" class="btn btn-sm bg-gradient-danger">Cancel</router-link>
          <button v-on:click="updateRegister" class="btn btn-sm bg-gradient-success mr-2 float-end">Update</button>                                                    
        </div>        
      </div>
    </div>    
  </template>
  
  <script>
  import axios from 'axios'
  import useValidate from '@vuelidate/core'
  import { required, helpers, email as emailValidator} from '@vuelidate/validators'
  import { reactive, computed } from 'vue'
  import Error from '../../../components/GlobalAlert.vue'
  
  export default {
    name: "RegisterDetail",
    setup() {
        const state = reactive ({            
            register: [],            
            id: '',
            email: '',
            displayName: '',
            animalSpecies: '',
            address: '',
            city: '',
            zipcode: '',
            telephoneNumber: '',
            mobileNumber: '',            
        })

        const rules = computed(() => {
            return {
              email: { 
                required: helpers.withMessage(this.$t('common.Required'), required), 
                email: helpers.withMessage(this.$t('common.Invalid_email_address'), emailValidator) 
              },
              displayName: { 
                    required: helpers.withMessage(this.$t('common.Required'), required)
              },
              animalSpecies: { 
                    required: helpers.withMessage(this.$t('common.Required'), required)
              }
            }
        })  
        
        const v$ = useValidate(rules, state)

        return {
            state,
            v$
        }
    },    
    components: {
      Error      
    },
    data() {
      return {
        register: [],
        gets: [],
        error: '',        
      };
    },
    async mounted() {  
      this.id = this.$route.params.id;                
      await this.fetchRegisterData(this.$route.params.id);      
    },
    methods: {      
      async fetchRegisterData(registerId) {
        try {
            
            this.$store.commit('setShowLoading', true);

            const response = await axios.get(`Register/${registerId}`);
            this.gets = response.data;

            if (this.gets.success) {
                this.state.register = this.gets.data;
                this.state.id = this.state.register.id;
                this.state.email = this.state.register.email;
                this.state.displayName = this.state.register.displayName;
                this.state.animalSpecies = this.state.register.animalSpecies;                              
                this.state.address = this.state.register.address;
                this.state.city = this.state.register.city;
                this.state.zipcode = this.state.register.zipcode;
                this.state.telephoneNumber = this.state.register.telephoneNumber;
                this.state.mobileNumber = this.state.register.mobileNumber;
            } else {
                this.error = 'Oops!! Error contact system admin.';
            }
        } catch (e) {
            this.error = 'Oops!! Error contact system admin.';
        }
        
        this.$store.commit('setShowLoading', false);
      },
      
      async updateRegister() {   
            try {
                this.$store.commit('setShowLoading', true);

                this.v$.$validate();                
                console.log(this.v$.$error);

                if(!this.v$.$error) {
                    const response = await axios.put('Register/update', {
                      "id": this.state.id,
                      "email": this.state.email,            
                      "displayName": this.state.displayName,
                      "animalSpecies": this.state.animalSpecies,
                      "address": this.state.address,
                      "city": this.state.city,
                      "zipcode": this.state.zipcode,
                      "telephoneNumber": this.state.telephoneNumber,
                      "mobileNumber": this.state.mobileNumber,
                    });
                    this.gets = response.data;

                    if (this.gets.success) {
                        this.$swal.fire({
                            text: "Success, Register updated successfully!",
                            icon: "success",
                            position: "top-end",
                            timer: 1000,
                        });
                        this.$router.push('/register');
                    } else {
                        this.error = 'Oops!! Error contact system admin.';
                    }
                }                
            } catch (e) {
                this.error = 'Oops!! Error contact system admin.';
            }                        
            this.$store.commit('setShowLoading', false);
      },
    }
  };
  </script>  